
import { Options, Vue } from "vue-class-component";
import NewTitleModal from "@/components/NewTitleModal.vue";

@Options({
  components: {
    NewTitleModal,
  },
  props: {
    titles: {
      type: Array,
      default: [],
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
  },
})
export default class TitleList extends Vue {
  openNewTitleModal(): void {
    // @ts-expect-error unknown
    this.$refs.modal.open();
  }
}
